import { cn } from "@/lib/utils";
import type { TimelineSegment, DailyTimelineLabels } from "./types";

interface SegmentSwitchProps {
  value: TimelineSegment;
  onChange: (next: TimelineSegment) => void;
  labels: DailyTimelineLabels;
}

const ORDER: TimelineSegment[] = ["all", "active", "done"];

export function SegmentSwitch({ value, onChange, labels }: SegmentSwitchProps) {
  return (
    <div
      role="tablist"
      aria-label={labels.title}
      className="px-3 py-2 flex items-center gap-2 border-b border-biz-border bg-biz-bg sticky top-[64px] z-10"
    >
      {ORDER.map((seg) => {
        const active = seg === value;
        return (
          <button
            key={seg}
            role="tab"
            type="button"
            aria-selected={active}
            onClick={() => onChange(seg)}
            className={cn(
              "h-12 px-4 rounded-full text-sm font-semibold transition-colors biz-motion-safe biz-focus-ring",
              active
                ? "bg-biz-primary text-biz-primary-foreground"
                : "bg-transparent border border-biz-border text-biz-foreground-muted hover:bg-biz-muted",
            )}
          >
            {labels.segment[seg]}
          </button>
        );
      })}
    </div>
  );
}
